import script from "./BaseNotificationComponent.vue?vue&type=script&lang=js"
export * from "./BaseNotificationComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__